var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { role: "main" } }, [
    _c("div", { staticClass: "d-print-none float-lg-right mb-3" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary login-page-button",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.close()
            }
          }
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("Btn_ClosePrivacyPolicy")) + "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-secondary login-page-button",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.print()
            }
          }
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("Btn_PrintPrivacyPolicy")) + "\n    "
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("AccessibilityStatementTitle")))]),
        _vm._v(" "),
        _vm.showFinnish
          ? _c("div", [
              _c("p", [
                _vm._v("\n          Palveluamme koskee "),
                _c(
                  "a",
                  {
                    staticClass: "normal-link",
                    attrs: {
                      href: "https://www.finlex.fi/fi/laki/alkup/2019/20190306",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }
                  },
                  [
                    _vm._v("laki digitaalisten palvelujen tarjoamisesta"),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("-. " + _vm._s(_vm.$t("NewWindow")))
                    ])
                  ]
                ),
                _vm._v(
                  " (306/2019), jossa edellytetään, että julkisten verkkopalvelujen on oltava saavutettavia. Sosiaali- ja terveysjärjestöjen avustuskeskus (STEA) pyrkii takaamaan STEA Verkkoasiointi -palvelun saavutettavuuden tämän lain mukaisesti.\n        "
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Tämä saavutettavuusseloste koskee asiointi.stea.fi-sivustoa."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("Palvelumme saavutettavuuden tila")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Palvelumme täyttää Verkkosisällön saavutettavuusohjeiden (WCAG 2.1) tasojen A ja AA vaatimukset osittain. Vaatimusten noudattamatta jättämiset ja vaatimuksiin sovellettavat poikkeukset mainitaan jäljempänä."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("Palvelumme ei-saavutettava sisältö")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Palvelulle on tehty pyynnöstämme ulkopuolisen tahon (Eficode Oy) saavutettavuusarviointi syyskuussa 2023. Tämä seloste on laadittu sen jälkeen, kun arvioinnissa ehdotetut saavutettavuuskorjaukset on tehty palveluun."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Ei-saavutettava sisältö esitellään kolmessa eri osassa:"
                )
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("h2", [_vm._v("1. Lain 306/2019 noudattamatta jättäminen")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Syyskuussa 2023 toteutetun saavutettavuusarvioinnin jälkeen olemme korjanneet palvelussa tunnistetut kriittisimmät saavutettavuusongelmat."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("2. Kohtuuton rasite")]),
              _vm._v(" "),
              _c("h3", [_vm._v("Skaalautuvuus")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Avustushakemus-, vuosiselvitys- ja tuloksellisuusraporttilomakkeet sisältävät elementtejä, jotka katoavat osin tai kokonaan näkyvistä mobiilissa, kapealla näytöllä ja 400 %:n suurennuksella. (WCAG 1.4.10). Edellä mainitut lomakkeet sisältävät taulukkoelementtejä, joiden korvaaminen muuttaisi palvelun käyttökokemusta merkittävästi.\n        "
                )
              ]),
              _vm._v(" "),
              _c("h3", [_vm._v("PDF-tiedostot")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "PDF-tiedoston Html-rakenne on osittain monimutkainen, joka johtuu palvelussa käytettävästä PDF-ohjelmiston lähdekoodista. (yleinen saavutettavuus). STEAlla ei ole mahdollisuutta vaikuttaa PDF-ohjelmiston lähdekoodiin."
                )
              ]),
              _vm._v(" "),
              _c("h2", [
                _vm._v("3. Lain ulkopuolella olevat saavutettavuusongelmat")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Laki digitaalisten palvelujen tarjoamisesta (306/2019) ei koske ennen 23.9.2018 julkaistuja liitetiedostoja."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("Tämän saavutettavuusselosteen laatiminen")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Tämä seloste on laadittu 21.3.2024. Seloste perustuu ulkopuolisen asiantuntijaorganisaation (Eficode Oy) toteuttamaan arviointiin siitä, täyttääkö verkkosivusto "
                ),
                _c(
                  "a",
                  {
                    staticClass: "normal-link",
                    attrs: {
                      href: "https://www.finlex.fi/fi/laki/alkup/2019/20190306",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }
                  },
                  [
                    _vm._v(
                      "Lain digitaalisten palvelujen tarjoamisesta 306/2019"
                    ),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("-. " + _vm._s(_vm.$t("NewWindow")))
                    ])
                  ]
                ),
                _vm._v(" vaatimukset.")
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("Palaute ja yhteystiedot")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Huomasitko saavutettavuuspuutteen digipalvelussamme? Kerro se meille ja teemme parhaamme puutteen korjaamiseksi."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("Ota yhteyttä sähköpostilla asiointituki.stea@gov.fi.")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "STEA Verkkoasiointi -palvelun saavutettavuudesta ja palautteiden käsittelystä vastaa Sosiaali- ja terveysjärjestöjen avustuskeskus (STEA)."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Lain mukaisena valvontaviranomaisena toimii Etelä-Suomen aluehallintovirasto, joka valvoo säädettyjen velvollisuuksien ja vaatimusten noudattamista."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("Täytäntöönpanomenettely")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Jos huomaat sivustollamme saavutettavuusongelmia, anna ensin palautetta meille."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Vastauksessamme voi mennä 14 päivää. Jos et ole tyytyväinen saamaasi vastaukseen tai et saa vastausta lainkaan kahden viikon aikana, voit antaa palautetta Etelä-Suomen aluehallintovirastoon."
                )
              ]),
              _vm._v(" "),
              _c("h3", [_vm._v("Valvontaviranomaisen yhteystiedot")]),
              _vm._v(" "),
              _c("p", [
                _c("span", [
                  _vm._v(
                    "\n            Liikenne- ja viestintävirasto Traficom "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n            Digitaalisen esteettömyyden ja saavutettavuuden valvontayksikkö "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "normal-link",
                      attrs: {
                        href: "https://www.saavutettavuusvaatimukset.fi/",
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }
                    },
                    [
                      _vm._v("www.saavutettavuusvaatimukset.fi"),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("-. " + _vm._s(_vm.$t("NewWindow")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    { attrs: { href: "mailto:saavutettavuus@traficom.fi" } },
                    [_vm._v("saavutettavuus@traficom.fi")]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "normal-link",
                      attrs: {
                        href:
                          "https://www.saavutettavuusvaatimukset.fi/fi/kayttajan-oikeudet/tee-saavutettavuuskantelu-tai-pyyda-selvitysta/saavutettavuuskantelu-tai",
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }
                    },
                    [
                      _vm._v(
                        "Ilmoita saavutettavuusongelmasta verkkolomakkeella"
                      ),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("-. " + _vm._s(_vm.$t("NewWindow")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n            puhelinnumero vaihde 029 534 5000\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("h2", [
                _vm._v(
                  "Teemme jatkuvasti työtä saavutettavuuden parantamiseksi"
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Olemme sitoutuneet digipalveluiden saavutettavuuden parantamiseen ja korjaamme havaitut saavutettavuuspuutteet mahdollisimman pian."
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showSwedish
          ? _c("div", [
              _c("p", [
                _vm._v(
                  "\n          Social- och hälsoorganisationernas understödscentral (STEA) vill säkerställa tillgängligheten av STEAs e-tjänst enligt "
                ),
                _c(
                  "a",
                  {
                    staticClass: "normal-link",
                    attrs: {
                      href: "https://www.finlex.fi/sv/laki/alkup/2019/20190306",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }
                  },
                  [
                    _vm._v(
                      "lagen om tillhandahållande av digitala tjänster 306/2019"
                    ),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("-. " + _vm._s(_vm.$t("NewWindow")))
                    ])
                  ]
                ),
                _vm._v(".\n        ")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Det här tillgänglighetsutlåtandet gäller webbplatsen asiointi.stea.fi."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("Tjänstens fullgörandestatus")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Webbplatsen är delvis förenlig med WCAG 2.1 -riktlinjerna på nivå A och AA. Exempel på bristande förenlighet och undantag förtecknas nedan."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("Tjänstens otillgängliga innehåll")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "En utomstående organisation (Eficode Oy) har utfört en bedömning av webbplatsens tillgänglighet i september 2023. Utlåtandet har skapats efter att de tillgänglighetskorrigeringar som utvärderingen föreslog har genomförts."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Innehållet som förtecknas nedan är inte tillgängligt på grund av:"
                )
              ]),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("h2", [_vm._v("1. Bristande förenlighet med lagen 306/2019")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Efter utvärderingen i september 2023 har vi åtgärdat de mest kritiska tillgänglighetsproblem som identifierats i tjänsten."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("2. Oproportionell börda")]),
              _vm._v(" "),
              _c("h3", [_vm._v("Skalbarhet")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          Blanketterna för ansökan om understöd, årsredovisningen och resultatrapporten innehåller element som helt eller delvis försvinner ur synhåll på en mobil, smal skärm och en förstoring på 400 procent. (WCAG 1.4.10). De ovannämnda blanketterna innehåller tabellelement vars ersättande avsevärt förändrar upplevelsen av att använda tjänsten.\n        "
                )
              ]),
              _vm._v(" "),
              _c("h3", [_vm._v("PDF-filer")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "HTML-strukturen för PDF-filen är delvis komplex på grund av den PDF-källkod som används i tjänsten. (allmän tillgänglighet). STEA har inte möjlighet att påverka källkoden för PDF-programmet."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("3. Innehållet omfattas inte av lagen")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Lagen om tillhandahållande av digitala tjänster 306/2019 gäller inte bilagor som publicerats före den 23 september 2018."
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("h2", [
                _vm._v("Beredningen av detta tillgänglighetsutlåtande")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Detta utlåtande har upprättats den 21 mars 2024. Utlåtandet baserar sig på en bedömning utfört av en utomstående expertorganisation (Eficode Oy) om hur webbplatsen uppfyller kraven "
                ),
                _c(
                  "a",
                  {
                    staticClass: "normal-link",
                    attrs: {
                      href: "https://www.finlex.fi/sv/laki/alkup/2019/20190306",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }
                  },
                  [
                    _vm._v(
                      "i lagen om tillhandahållande av digitala tjänster 306/2019"
                    ),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("-. " + _vm._s(_vm.$t("NewWindow")))
                    ])
                  ]
                ),
                _vm._v(".")
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("Respons och kontaktuppgifter")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Upptäckte du ytterligare tillgänglighetsbrister i tjänsten? Meddela oss så gör vi vårt bästa för att rätta till bristerna."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("Ta kontakt per e-post: asiointituki.stea@gov.fi.")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Social- och hälsoorganisationernas understödscentral (STEA) ansvarar för tillgängligheten och responshanteringen på webbplatsen asiointi.stea.fi"
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Tillsynsmyndigheten enligt lagen är Regionförvaltningsverket i Södra Finland som övervakar fullgörandet av skyldigheter och iakttagandet av krav."
                )
              ]),
              _vm._v(" "),
              _c("h2", [_vm._v("Uppföljningsförfarande")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Kontakta oss om du vill påtala brister i tillgängligheten på webbplatsen."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Det kan ta 14 dagar innan du får svar. Om du inte är nöjd med svaret du har fått, eller inte får något svar alls inom två veckor, kan du lämna en anmälan om bristande tillgänglighet till Regionförvaltningsverket i Södra Finland."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "På regionförvaltningsverkets webbplats står det hur man kan lämna en anmälan samt hur ärendet behandlas."
                )
              ]),
              _vm._v(" "),
              _c("h3", [_vm._v("Tillsynsmyndighetens kontaktuppgifter")]),
              _vm._v(" "),
              _c("p", [
                _c("span", [
                  _vm._v(
                    "\n            Transport- och kommunikationsverket Traficom "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n            Enheten för tillsyn över digital tillgänglighet "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "normal-link",
                      attrs: {
                        href: "https://www.tillganglighetskrav.fi",
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }
                    },
                    [
                      _vm._v("www.tillganglighetskrav.fi "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("-. " + _vm._s(_vm.$t("NewWindow")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    { attrs: { href: "mailto:tillganglighet@traficom.fi" } },
                    [_vm._v("tillganglighet@traficom.fi")]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "normal-link",
                      attrs: {
                        href:
                          "https://www.saavutettavuusvaatimukset.fi/sv/dina-rattigheter/lamna-en-tillganglighetsklagan-eller-be-om-en-utredning",
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }
                    },
                    [
                      _vm._v("Lämna en tillgänglighetsklagan på webben"),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("-. " + _vm._s(_vm.$t("NewWindow")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n            telefonnummer växeln 029 534 5000\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("h2", [
                _vm._v("Vi arbetar ständigt med att förbättra tillgängligheten")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Vi vill ständigt förbättra tillgängligheten på våra digitala tjänster och kommer att rätta till de upptäckta bristerna så fort som möjligt."
                )
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "ml-3" }, [
        _vm._v(
          "1.\tSaavutettavuusongelmat, joita Laki digitaalisten palvelujen tarjoamisesta 306/2019 koskee "
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "ml-3" }, [
        _vm._v("2.\tKohtuuttomasta rasitteesta johtuvat saavutettavuusongelmat")
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "ml-3" }, [
        _vm._v("3.\tLain ulkopuolella olevat saavutettavuusongelmat.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "ml-3" }, [
        _vm._v(
          "1.\tBristande förenlighet med lagen om tillhandahållande av digitala tjänster 306/2019"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "ml-3" }, [_vm._v("2.\tOproportionell börda")]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "ml-3" }, [
        _vm._v(
          "3.\tInnehållet omfattas inte av den tillämpliga lagstiftningen."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }